import { useIntl } from 'react-intl';
import { useResetRecoilState } from 'recoil';
import React from 'react';
import ToolbarLayer from './ToolbarLayer';
import Config from '../../../config';
import PanelsLayer from './PanelsLayer';
import GoogleMap from './GoogleMapLayer';
import WaypointsLayer from './WaypointsLayer';
import Bounds from './GoogleMapLayer/Bounds';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import StreetviewLayer from './StreetviewLayer';
import Logic from './Logic';
import {
  activeFilterBluecoinsAtom,
  bluecoinIdAtom,
  bluecoinsAtom,
  filteredBluecoinsAtom,
  filteredBluecoinStringAtom,
  isBluecoinsOpenAtom,
  selectedBluecoinsAtom,
} from './Bluecoins/BluecoinState';

function OnlineMapNew(): JSX.Element {
  const [googleMap, setGoogleMap] = React.useState<google.maps.Map | undefined>();
  const { formatMessage: f } = useIntl();
  useDocumentTitle(f({ id: 'menu.map' }));
  const resetBluecoins = useResetRecoilState(bluecoinsAtom);
  const resetFilteredBluecoins = useResetRecoilState(filteredBluecoinsAtom);
  const resetFilteredBluecoinString = useResetRecoilState(filteredBluecoinStringAtom);
  const resetActiveFilterBluecoins = useResetRecoilState(activeFilterBluecoinsAtom);
  const resetBluecoinId = useResetRecoilState(bluecoinIdAtom);
  const resetIsBluecoinsOpen = useResetRecoilState(isBluecoinsOpenAtom);
  const resetSelectedBluecoins = useResetRecoilState(selectedBluecoinsAtom);

  React.useEffect(() => {
    return () => {
      resetBluecoins();
      resetFilteredBluecoins();
      resetFilteredBluecoinString();
      resetActiveFilterBluecoins();
      resetBluecoinId();
      resetIsBluecoinsOpen();
      resetSelectedBluecoins();
    };
  }, [
    resetActiveFilterBluecoins,
    resetBluecoinId,
    resetBluecoins,
    resetFilteredBluecoinString,
    resetFilteredBluecoins,
    resetIsBluecoinsOpen,
    resetSelectedBluecoins,
  ]);

  return (
    <div
      id="google-map-fullscreen"
      style={{ width: '100%', height: '100%', position: 'absolute', overflow: 'hidden' }}
    >
      <GoogleMap googleMap={googleMap} setGoogleMap={setGoogleMap} />
      <Bounds googleMap={googleMap} />
      <PanelsLayer googleMap={googleMap} />
      <WaypointsLayer googleMap={googleMap} />
      <StreetviewLayer googleMap={googleMap} />
      <ToolbarLayer
        googleMap={googleMap}
        trafficLayerControl={Config.onlineMap.toolbar.trafficLayerControl}
        vehicleChipsControl={Config.onlineMap.toolbar.vehicleChipsControl}
        vehicleFocusControl={Config.onlineMap.toolbar.vehicleFocusControl}
        autofocusControl={Config.onlineMap.toolbar.autoFocusControl}
        waypointsControl={Config.onlineMap.toolbar.waypointsControl}
        vehicleSearchControl={Config.onlineMap.toolbar.vehicleSearchControl}
        bluecoinsControl={Config.onlineMap.toolbar.bluecoinsControl}
      />
      <Logic googleMap={googleMap} />
    </div>
  );
}

export default React.memo(OnlineMapNew);
